import { createClient } from "@supabase/supabase-js";
import type { Database } from "@/lib/supabase/database.types";

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

/**
 * Typed Supabase client. Every query into `public.*` tables gets row-type
 * inference against the generated /src/lib/supabase/database.types.ts.
 *
 * RLS is enforced server-side — the anon key never sees another org's
 * data because `diyafa_current_org_ids()` resolves per authenticated user.
 */
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey);

export type { Database } from "@/lib/supabase/database.types";
